import { DictionaryContextType } from '../dictionaries/context/DictionaryContextTypes';
import { BankType, BrandType, NegotiationOption, NegotiationOptionAlternative, NegotiationOptionAlternativeType, OutDebt, OutDebtFieldsFragment } from '../generated/graphql';

type ContentBalanceBehindPaymentBancoBogotaType = {
  gT: (key: string, context?: DictionaryContextType) => string,
  outDebt: OutDebt,
  negOption?: NegotiationOption,
  outDebts?: Array<OutDebtFieldsFragment>,
  alternative?: NegotiationOptionAlternative,

};

// this was an enum for some reason...
const bancoBogotaBalanceBehindPaymentKeys = {
  General: 'negotiation_BalanceBehindPayment_consequences',
  Multidebt: 'negotiation_BalanceBehindPayment_consequences_multidebt',
  Traditional: `negotiation_BalanceBehindPayment_consequences_${NegotiationOptionAlternativeType.Traditional}`,
  LowRate: `negotiation_BalanceBehindPayment_consequences_${NegotiationOptionAlternativeType.LowRate}`,
  NoPayment: `negotiation_BalanceBehindPayment_consequences_${NegotiationOptionAlternativeType.NoPayment}`,
};

export const getContentBalanceBehindPaymentBancoBogota = (
  props : ContentBalanceBehindPaymentBancoBogotaType,
) => {
  const { gT, outDebts, outDebt, alternative } = props;
  const keys = [ gT(bancoBogotaBalanceBehindPaymentKeys.General) ];

  if (alternative?.type === NegotiationOptionAlternativeType.Traditional) {
    return gT(bancoBogotaBalanceBehindPaymentKeys.Traditional);
  }

  if (alternative?.type === NegotiationOptionAlternativeType.LowRate) {
    keys.push(gT(bancoBogotaBalanceBehindPaymentKeys.LowRate));
  }

  if (alternative?.type === NegotiationOptionAlternativeType.NoPayment) {
    keys.push(gT(bancoBogotaBalanceBehindPaymentKeys.NoPayment));
  }

  const isMultiDebt = outDebts && outDebts.filter(({ bank, brand }) => (
    bank === BankType.BancoDeBogota && brand === BrandType.Tranquiapp
  )).length > 1;

  const outDebtHeadProductNumber = outDebts?.find(({ bank, brand, extra }) => (
    bank === BankType.BancoDeBogota && brand === BrandType.Tranquiapp && extra?.headProductNumber
  ))?.productNumber;

  if (isMultiDebt
    && outDebtHeadProductNumber
    && !outDebt.productNumber?.includes(outDebtHeadProductNumber)) {
    keys.push(gT(bancoBogotaBalanceBehindPaymentKeys.Multidebt,
      { headProductNumber: outDebtHeadProductNumber }));
  }

  return keys.join(' ');
};
